<template>

    <div class="input-group" v-if="lazy === true">
        
        <input class="form-control form-control-sm border border-dark" type="text" v-model.lazy.trim="query" placeholder="Search">
        <span class="input-group-append">
            <button @click="filter()" class="btn btn-outline-secondary border border-dark" type="button">
                <i class="fa fa-search"></i>
            </button>
        </span>

    </div>

    <input class="form-control form-control-sm border border-dark" v-else type="text" v-model.trim="query" placeholder="Search">

</template>

<script>
import Utils from '../mixins/ObjectUtilsMixin';

export default {
    mixins: [Utils],

    props: {
        list: {},

        filteredList: {},

        fields: {},

        lazy: {

            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            query: '',
        };
    },

    watch: {
        list: function() {
            this.copyToFilteredList(this.list);
            this.filter();
        },

        query: function() {
            this.filter();
        },
    },

    mounted: function() {
        this.filter();
    },

    methods: {
        filter() {
            if (this.query.length > 0) {
                this.copyToFilteredList(
                    this.list.filter(item => {
                        let passes = [];

                        this.fields.forEach(key => {
                            let val = this.dotGet(key, item);
                            if (!val) {
                                return;
                            }

                            passes.push(
                                val.toString().toLowerCase().indexOf(this.query.toLowerCase()) > -1
                            );
                        });

                        return passes.some(pass => pass);
                    })
                );
            } else {
                this.copyToFilteredList(this.list);
            }
        },

        emptyFilteredList() {
            if (this.filteredList.length > 0) {
                this.filteredList.splice(0);
            }
        },

        copyToFilteredList(array) {
            this.emptyFilteredList();
            this.filteredList.push.apply(this.filteredList, array);
        },

    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/table-components/SearchBoxComponent.vue